<template>
  <div class="p-4" v-if="data.room_rate">
    <div class="row">
      <!-- GENERAL INFORMATION -->
      <div class="col-12 mb-4">
        <div class="row no-gutters">
          <div class="col-3">
            <img
              v-if="data.room_rate.room_type.image != ''"
              :src="data.room_rate.room_type.image[0].image_url" 
              class="w-100 rounded-3">
            <img
              v-else
              src="../../../assets/img/icon/hotel-placeholder.svg" 
              class="w-100 rounded-3">
          </div>
          <div class="col-9">
            <div class="pl-3">
              <p class="body-1-4 mb-1">{{data.room_rate.name}}</p>
              <div class="w-100 no-ws mb-1">
                <img src="../../../assets/img/icon/bed.png" height="12" class="mr-2 d-inline-block align-middle">
                <p class="body-3-1 mb-0 d-inline-block align-middle">{{data.qty}} {{$t('hotel.unit-type.'+data.room_rate.room_type.type+'.unit')}}</p>
              </div>
              <div class="w-100 no-ws mb-1">
                <img src="../../../assets/img/icon/calendar.png" height="12" class="mr-2 d-inline-block align-middle">
                <p class="body-3-1 mb-0 d-inline-block align-middle">{{ $formatDateRange(getBeFilter.date.check_in,getBeFilter.date.check_out) }}, {{ `${total_night} ${$pluralWord(total_night,'Night')}` }}</p>
              </div>
              <p class="body-3-1 mb-0 text-green cursor-pointer" @click="openDetail">View Detail</p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- PAX -->
      <div class="col-12 mb-4" v-for="(guest,index) in pax">
        <div class="p-3 rounded-6 border-semi-grey">
          <div class="mb-3 pb-3 border-b-semi-grey">
            <p class="mb-0 sub-heading-1-2 w-100 text-orange">Room #{{index+1}}</p>
            <!-- <p class="mb-0 body-3-3-1 w-100">Guest included : {{ guest_included }}, Maximum guest : {{ max_guest }}</p> -->
          </div>
          <div v-for="(type,typeIndex) in paxType" class="row no-gutters" 
          :class="{
            'pt-3 mt-3 border-top': typeIndex != 0
          }">
            <div class="col-8">
              <p class="mb-0 body-1-4">{{ type.title }}</p>
              <p class="mb-0 body-2-2 font-regular">{{ type.subtitle }}</p>
              <p class="mb-0 body-3 text-danger" v-if="extra_guest[index][type.id] > 0">{{ printExtraGuest(extra_guest[index][type.id], type.id) }}</p>
            </div>
            <div class="col-4 text-center mt-1">
              <div class="row py-1 text-right w-100 no-gutters">
                <div class="col-4 text-center">
                  <img src="../../../assets/img/icon/decrement.png"
                    class="cursor-disable border rounded-100 p-2" width="35"
                    v-if="guest[type.id] <= type.minimum">
                  <img 
                    src="../../../assets/img/icon/minus-black.png"
                    class="cursor-pointer border rounded-100 p-2" 
                    width="35" v-else
                    @click="toggleCounter(index,'min', type.id, type.minimum)">
                </div>
                <div class="col-4 text-center">
                  <p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;">
                    {{guest[type.id]}}</p>
                </div>
                <div class="col-4 text-center">
                  <img src="../../../assets/img/icon/plus-black.png"
                    class="cursor-pointer border rounded-100 p-2" width="35"
                    @click="toggleCounter(index,'plus', type.id)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- PRICE -->
      <div class="col-12 mb-4">
        <div class="p-4 rounded-6 border-semi-grey">
          <div class="row slim-grid-row mb-4 pb-4 border-b-semi-grey">
            <p class="mb-0 sub-heading-1-2">Price Detail</p>
          </div>
          <div class="row slim-grid-row">
            <div class="col-6">
              <p class="mb-0 body-1-2">{{total_guest_included}}x {{$t('hotel.rate-breakdown.guest-included')}}</p>
            </div>
            <div class="col-6">
              <p class="mb-0 body-1-2 text-right">{{$formatCurrency(total_price.included)}}</p>
            </div>
          </div>
          <div class="row slim-grid-row mt-3" v-if="total_price.discount < 0">
            <div class="col-6">
              <p class="mb-0 body-1-2 text-green">Discount</p>
            </div>
            <div class="col-6">
              <p class="mb-0 body-1-2 text-right text-green">{{$formatCurrency(total_price.discount)}}</p>
            </div>
          </div>
          <!-- extra adult -->
          <div class="row slim-grid-row mt-3" v-if="extra_guest_total.adult > 0">
            <div class="col-6">
              <p class="mb-0 body-1-2">{{extra_guest_total.adult}}x {{$t('hotel.rate-breakdown.extra-adults')}}</p>
            </div>
            <div class="col-6">
              <p class="mb-0 body-1-2 text-right">{{$formatCurrency(total_price.extra.adult)}}</p>
            </div>
          </div>
          <!-- extra child -->
          <div class="row slim-grid-row mt-3" v-if="extra_guest_total.child > 0">
            <div class="col-6">
              <p class="mb-0 body-1-2">{{extra_guest_total.child}}x {{$t('hotel.rate-breakdown.extra-childs')}}</p>
            </div>
            <div class="col-6">
              <p class="mb-0 body-1-2 text-right">{{$formatCurrency(total_price.extra.child)}}</p>
            </div>
          </div>
          <!-- extra infant -->
          <div class="row slim-grid-row mt-3" v-if="extra_guest_total.infant > 0">
            <div class="col-6">
              <p class="mb-0 body-1-2">{{extra_guest_total.infant}}x {{$t('hotel.rate-breakdown.extra-infants')}}</p>
            </div>
            <div class="col-6">
              <p class="mb-0 body-1-2 text-right">{{$formatCurrency(total_price.extra.infant)}}</p>
            </div>
          </div>
          <div class="row slim-grid-row mt-3">
            <div class="col-6">
              <p class="mb-0 sub-heading-1-2">Total</p>
            </div>
            <div class="col-6">
              <p class="mb-0 sub-heading-1-2 text-right">{{$formatCurrency(total_price.total)}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- BUTTON -->
      <div class="col-12">
        <state-button block variant="primary" size="lg" :click="submitPax">Save Changes</state-button>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters,mapMutations } from 'vuex';

  export default {
    props: ['data'],
    data(){
      return{
        pax: []
      }
    },
    computed:{
      ...mapGetters(['getBeFilter','getMerchant']),
      total_night(){
        let different = moment(this.getBeFilter.date.check_out).diff(this.getBeFilter.date.check_in, 'd')
        return different
      },
      paxType(){
        let fullPax = [{ id: 'adult', minimum: 1, title: this.$t('hotel.adults.adults'), subtitle: this.getMerchant.adult_description }];
        if(this.getMerchant.search_room_is_show_filter_pax_child){
          fullPax.push({ id: 'child', minimum: 0, title: this.$t('hotel.children.children'), subtitle: this.getMerchant.children_description })
        }
        if(this.getMerchant.search_room_is_show_filter_pax_infant){
          fullPax.push({ id: 'infant', minimum: 0, title: this.$t('hotel.infants.infants'), subtitle: this.getMerchant.infant_description })
        }
        
        return fullPax
      },
      max_guest(){
        let mg_rate = this.data.room_rate.rate.max_guests
        let mg_room_type = this.data.room_rate.room_type.max_guests
        return mg_rate == null ? mg_room_type : mg_rate
      },
      maxGuest() {
        const { rate, room_type } = this.data.room_rate;
        const maxGuestSource = rate.max_guests ? rate : room_type;

        return {
          use_max_guest_by_pax: maxGuestSource.use_max_guest_by_pax || false,
          max_guests: maxGuestSource.max_guests || null,
          max_guest_adult: maxGuestSource.max_guest_adult || 0,
          max_guest_children: maxGuestSource.max_guest_children || 0,
          max_guest_infant: maxGuestSource.max_guest_infant || 0,
        };
      },
      guest_included(){
        return this.data.room_rate.rate.guest_included
      },
      total_guest_included(){
        let total_guest = this.pax.reduce((acc,crt)=>{
          let total = crt.adult+crt.child+crt.infant
          return acc+total
        },0)

        let total_guest_included = this.guest_included*this.data.qty 
        
        return total_guest > total_guest_included ? total_guest_included : total_guest
      },
      extra_guest(){
        let extra = []

        this.pax.forEach((item,index)=>{
          let data = { adult: 0, child: 0, infant: 0 }
          const { use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant } = this.maxGuest;
          let totalGuest = Object.values(item).reduce((sum, value) => sum + value, 0);
          if(totalGuest > this.guest_included){
            if(use_max_guest_by_pax){
              const GUEST_TYPE = ['infant','child', 'adult'];
              const maxGuestType = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant }
              
              let remainingGuest = totalGuest - this.guest_included;
              for (const type of GUEST_TYPE){
                if(remainingGuest > 0 && item[type] > 0){
                  const extraFinal = Math.min(remainingGuest, maxGuestType[type]);
                  data[type] = extraFinal;
                  remainingGuest -= extraFinal;
                }
              }
              
            }else{
              if(item.adult >= this.guest_included){
                data = {
                  adult: item.adult-this.guest_included,
                  child: item.child,
                  infant: item.infant
                }
              }else{
                let remaining_total_included = {
                  child: this.guest_included - item.adult,
                  infant: this.guest_included - item.adult - item.child
                }
                if(item.child >= remaining_total_included.child){
                  data.child = item.child - remaining_total_included.child
                  data.infant = item.infant
                }else{
                  if(item.infant >= remaining_total_included.infant){
                    data.infant = item.infant - remaining_total_included.infant
                  }
                }
              }
            }
          }
          extra.push(data)
        })

        return extra
      },
      extra_guest_total(){
        let data = {
          adult: 0,
          child: 0,
          infant: 0
        }
        this.extra_guest.forEach(item=>{
          data.adult += item.adult
          data.child += item.child
          data.infant += item.infant
        })
        return data
      },
      total_price(){
        let data = {
          included: 0,
          discount: 0,
          extra:{
            adult: 0,
            child: 0,
            infant: 0
          },
          total: 0
        }
        
        this.pax.forEach((item_pax,pax_index)=>{
          this.data.room_rate.dates.forEach(item=>{
            data.included += item.price
            data.discount += item.promotion_price
            if(this.extra_guest[pax_index].adult > 0) data.extra.adult += (item.extra_guest.adult.amount * this.extra_guest[pax_index].adult)
            if(this.extra_guest[pax_index].child > 0) data.extra.child += (item.extra_guest.child.amount * this.extra_guest[pax_index].child)
            if(this.extra_guest[pax_index].infant > 0) data.extra.infant += (item.extra_guest.infant.amount * this.extra_guest[pax_index].infant)
          })
        })
        
        data.total = data.included+data.discount+data.extra.adult+data.extra.child+data.extra.infant

        return data
      }
    },
    mounted(){
      this.setupData()
    },
    methods:{
      ...mapMutations(['BeManipulateRoomRateGuest']),
      close(){
        this.$emit('close')
      },
      openDetail(){
        this.$emit('close')
        this.$emit('openDetail',this.data)
      },
      toggleCounter(index,type,field, minimum = 0){
        const isDecrementHitMinimum = type == 'min' && this.pax[index][field] <= minimum
        if(isDecrementHitMinimum) return;
        
        const {
          use_max_guest_by_pax,
          max_guests,
          max_guest_adult,
          max_guest_children,
          max_guest_infant,
        } = this.maxGuest;

        const totalGuest = Object.values(this.pax[index]).reduce((sum, value) => sum + value, 0)
        const maxGuestType = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant}

        const canChangeUpTotal = totalGuest < max_guests
        const canChangeUpSpecific = this.pax[index][field] < maxGuestType[field] && canChangeUpTotal
        const canChangeUp = use_max_guest_by_pax ? canChangeUpSpecific : canChangeUpTotal;
        
        if(type == 'min' || (type == 'plus' && canChangeUp)){
          const currentPax = this.pax[index][field];
          this.pax[index][field] = type == 'min' ? currentPax-1 : currentPax+1;
        }else{
          console.log("Anda sudah mencapai limit")
        }
      },
      setupData(){
        this.data.guest.forEach(item=>{
          let cloned_data = this.$deepCopy(item)
          let adjust_pax = Object.entries(cloned_data.included).reduce((acc, [key, value]) =>({ ...acc, [key]: (acc[key] || 0) + value }), { ...cloned_data.extra });
          this.pax.push(adjust_pax)      
        })
      },
      printExtraGuest(num,type){
        let base = 'counted as extra guest'
        let plural = num > 1 ? 'are' : 'is'
        let text = `${num} ${this.$pluralWord(num,type)} ${plural} ${base}${num>1?'s':''}`
        return text
      },
      submitPax(){
        return new Promise((success,fail)=>{
          setTimeout(()=>{
            let params = { 
              id: this.data.room_rate.id, 
              guest: {
                included: this.$deepCopy(this.pax),
                extra: this.extra_guest
              } 
            }
            this.pax.forEach((item,index)=>{
              params.guest.included[index].adult -= this.extra_guest[index].adult
              params.guest.included[index].child -= this.extra_guest[index].child
              params.guest.included[index].infant -= this.extra_guest[index].infant
            })
            console.log(params)
            this.BeManipulateRoomRateGuest(params)
            this.close()
            success()
          },300)
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/AdjustPax.vue